module.exports = __webpack_public_path__ + "media/images/fonts/inter.var-aaa17e8f090e449283a16ad1e23c2e90.woff2";